import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { memo } from 'react';
import PropTypes from 'prop-types';
import useChartUpdate from '../UseChartUpdate';
var Legend = memo(function (_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      restProps = _objectWithoutProperties(_ref, ["children", "enabled"]);

  useChartUpdate(_objectSpread({
    enabled: enabled
  }, restProps), updateLegend, function (chart) {
    return updateLegend(chart, {
      enabled: false
    });
  }, false);
  return children;
});

var updateLegend = function updateLegend(chart, config) {
  chart.update({
    legend: config
  }, false);
};

Legend.propTypes = {
  enabled: PropTypes.bool
};
Legend.displayName = 'Legend';
export default Legend;